import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "patients-container" }
const _hoisted_2 = { class: "patient-filters" }
const _hoisted_3 = {
  key: 0,
  class: "patients-list pe-1"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "xd-flex flex-column align-items-center justify-content-between" }
const _hoisted_6 = { class: "fw-bold" }
const _hoisted_7 = {
  key: 1,
  class: "text-center py-2",
  ref: "trigger"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw fa-2x" }, null, -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, "Loading...", -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "patient-details-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonFilters = _resolveComponent("CommonFilters")!
  const _component_ProductPill = _resolveComponent("ProductPill")!
  const _component_ScrollPagination = _resolveComponent("ScrollPagination")!
  const _component_HosPalPatientDetails = _resolveComponent("HosPalPatientDetails")!
  const _component_HHPatientDetails = _resolveComponent("HHPatientDetails")!
  const _component_HCPatientDetails = _resolveComponent("HCPatientDetails")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CommonFilters, { filtersChanged: _ctx.getPatientsList }, null, 8 /* PROPS */, ["filtersChanged"]),
      _createVNode(_component_ScrollPagination, {
        "page-number": _ctx.pageNumber,
        onPageNumberUpdate: _ctx.pageNumberUpdated,
        class: "h-100 overflow-hidden"
      }, {
        default: _withCtx(() => [
          _createElementVNode("section", {
            class: _normalizeClass(`ps-2 pt-2 bg-white d-flex flex-column patients-list pe-1 scroll-paginate  ${_ctx.userOs == 'Windows' ? 'custom-scrollbar' : ''}`)
          }, [
            (!_ctx.patientsList.length && !_ctx.showLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, "No patients found"))
              : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patientsList, (patient) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(`patient-card mb-2 ${_ctx.selectedPatient.Id === patient.Id ? 'selected' : ''}`),
                key: patient.Id,
                onClick: ($event: any) => (_ctx.selectPatient(patient))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_ProductPill, {
                    class: "me-2",
                    "product-id": _ctx.getApplicationId(patient.Application)
                  }, null, 8 /* PROPS */, ["product-id"]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.formatName(patient.FirstName, patient.LastName, "LN, FN", "", patient.MiddleInitial)), 1 /* TEXT */),
                  _createElementVNode("div", null, _toDisplayString(patient.Mrn), 1 /* TEXT */)
                ])
              ], 10 /* CLASS, PROPS */, _hoisted_4))
            }), 128 /* KEYED_FRAGMENT */)),
            (_ctx.showLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10, 512 /* NEED_PATCH */))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["page-number", "onPageNumberUpdate"])
    ]),
    (!_ctx.loading && _ctx.selectedPatientDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (
                    _ctx.patientApplication === _ctx.ApplicationEnum.AxxessHospiceFE ||
                    _ctx.patientApplication === _ctx.ApplicationEnum.AxxessPalliative
                )
            ? (_openBlock(), _createBlock(_component_HosPalPatientDetails, {
                key: 0,
                selectedPatientDetails: _ctx.selectedPatientDetails,
                patientId: _ctx.selectedPatient.Id,
                agencyId: _ctx.selectedPatient.AgencyId,
                application: _ctx.selectedPatient.Application
              }, null, 8 /* PROPS */, ["selectedPatientDetails", "patientId", "agencyId", "application"]))
            : _createCommentVNode("v-if", true),
          (_ctx.patientApplication === _ctx.ApplicationEnum.AgencyCore)
            ? (_openBlock(), _createBlock(_component_HHPatientDetails, {
                key: 1,
                selectedPatientDetails: _ctx.selectedPatientDetails.Patient,
                patientRiskDetails: _ctx.selectedPatientDetails.PatientRiskDetails,
                patientTags: _ctx.selectedPatientDetails.PatientTags,
                patientDetails: _ctx.selectedPatientDetails,
                patientId: _ctx.selectedPatient.Id,
                agencyId: _ctx.selectedPatient.AgencyId,
                application: _ctx.patientApplication
              }, null, 8 /* PROPS */, ["selectedPatientDetails", "patientRiskDetails", "patientTags", "patientDetails", "patientId", "agencyId", "application"]))
            : _createCommentVNode("v-if", true),
          (_ctx.patientApplication === _ctx.ApplicationEnum.HomeCare)
            ? (_openBlock(), _createBlock(_component_HCPatientDetails, {
                key: 2,
                selectedPatientDetails: _ctx.selectedPatientDetails,
                patientId: _ctx.selectedPatient.Id,
                agencyId: _ctx.selectedPatient.AgencyId,
                application: _ctx.patientApplication
              }, null, 8 /* PROPS */, ["selectedPatientDetails", "patientId", "agencyId", "application"]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}